// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0a3b94f6","402":"1d28cac9","488":"1dde5848","551":"9971e52f","593":"18bb7491","639":"970632fa","751":"eb0dbaf3","779":"e415dca8"}[chunkId] + ".chunk.js";
};